import { render, staticRenderFns } from "./BomCharacteristic.vue?vue&type=template&id=06f8e64e"
import script from "./BomCharacteristic.vue?vue&type=script&lang=js"
export * from "./BomCharacteristic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports